"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JiraIssueChangelogFieldName = exports.JiraIssueChangelogFieldId = exports.JiraSprintState = void 0;
var JiraSprintState;
(function (JiraSprintState) {
    JiraSprintState["Active"] = "ACTIVE";
    JiraSprintState["Closed"] = "CLOSED";
    JiraSprintState["Future"] = "FUTURE";
})(JiraSprintState = exports.JiraSprintState || (exports.JiraSprintState = {}));
var JiraIssueChangelogFieldId;
(function (JiraIssueChangelogFieldId) {
    JiraIssueChangelogFieldId["Status"] = "status";
    JiraIssueChangelogFieldId["Assignee"] = "assignee";
    JiraIssueChangelogFieldId["Attachment"] = "attachment";
    JiraIssueChangelogFieldId["Comment"] = "comment";
    JiraIssueChangelogFieldId["Components"] = "components";
    JiraIssueChangelogFieldId["Description"] = "description";
    JiraIssueChangelogFieldId["DueDate"] = "duedate";
    JiraIssueChangelogFieldId["Environment"] = "environment";
    JiraIssueChangelogFieldId["FixVersions"] = "fixVersions";
    JiraIssueChangelogFieldId["IssueType"] = "issuetype";
    JiraIssueChangelogFieldId["Labels"] = "labels";
    JiraIssueChangelogFieldId["Priority"] = "priority";
    JiraIssueChangelogFieldId["Project"] = "project";
    JiraIssueChangelogFieldId["Reporter"] = "reporter";
    JiraIssueChangelogFieldId["Resolution"] = "resolution";
    JiraIssueChangelogFieldId["ResolutionDate"] = "resolutiondate";
    JiraIssueChangelogFieldId["Summary"] = "summary";
    JiraIssueChangelogFieldId["TimeEstimate"] = "timeestimate";
    JiraIssueChangelogFieldId["OriginalTimeEstimate"] = "timeoriginalestimate";
    JiraIssueChangelogFieldId["TimeSpent"] = "timespent";
    JiraIssueChangelogFieldId["Versions"] = "versions";
    JiraIssueChangelogFieldId["CustomField"] = "customfield";
})(JiraIssueChangelogFieldId = exports.JiraIssueChangelogFieldId || (exports.JiraIssueChangelogFieldId = {}));
var JiraIssueChangelogFieldName;
(function (JiraIssueChangelogFieldName) {
    JiraIssueChangelogFieldName["Status"] = "status";
    JiraIssueChangelogFieldName["Assignee"] = "assignee";
    JiraIssueChangelogFieldName["Attachment"] = "Attachment";
    JiraIssueChangelogFieldName["Comment"] = "Comment";
    JiraIssueChangelogFieldName["Components"] = "Component";
    JiraIssueChangelogFieldName["Description"] = "description";
    JiraIssueChangelogFieldName["DueDate"] = "duedate";
    JiraIssueChangelogFieldName["Environment"] = "environment";
    JiraIssueChangelogFieldName["FixVersions"] = "Fix Versions";
    JiraIssueChangelogFieldName["IssueType"] = "issuetype";
    JiraIssueChangelogFieldName["Labels"] = "labels";
    JiraIssueChangelogFieldName["Priority"] = "priority";
    JiraIssueChangelogFieldName["Project"] = "project";
    JiraIssueChangelogFieldName["IssueParentAssociation"] = "IssueParentAssociation";
    JiraIssueChangelogFieldName["Reporter"] = "reporter";
    JiraIssueChangelogFieldName["Resolution"] = "resolution";
    JiraIssueChangelogFieldName["ResolutionDate"] = "resolutiondate";
    JiraIssueChangelogFieldName["Summary"] = "summary";
    JiraIssueChangelogFieldName["TimeEstimate"] = "timeestimate";
    JiraIssueChangelogFieldName["OriginalTimeEstimate"] = "timeoriginalestimate";
    JiraIssueChangelogFieldName["TimeSpent"] = "timespent";
    JiraIssueChangelogFieldName["Sprint"] = "Sprint";
    JiraIssueChangelogFieldName["Versions"] = "Version";
})(JiraIssueChangelogFieldName = exports.JiraIssueChangelogFieldName || (exports.JiraIssueChangelogFieldName = {}));
//# sourceMappingURL=jira.js.map